import { inject } from "mobx-react";
import React, { Component } from "react";
import { DATA_EXPORTS } from "../constants/featureFlags";
import { GlobalSettingsContext } from "../providers/GlobalSettingsProvider";
import { MenuStructure } from "../types/nav";
import { getReportsMenuStructure } from "./ReportsMenuStructure";

interface SetActiveMenuProps {
  menuStructure: MenuStructure | Function;
  availableIntegrations?: IntegrationDetails[];
  store?: {
    IntegrationSyncStore: {
      availableIntegrations: unknown;
      loadAvailableIntegrations: Function;
    };
    MenuStore: {
      setSideMenuToDisplay: Function;
    };
  };
}

@inject("store")
class SetActiveMenu extends Component<SetActiveMenuProps> {
  static contextType = GlobalSettingsContext;
  context!: React.ContextType<typeof GlobalSettingsContext>;
  private previousDataExportsFlag?: string;

  getResolvedMenuStructure() {
    const { menuStructure, availableIntegrations } = this.props;

    let resolvedMenuStructure = menuStructure;
    if (availableIntegrations && typeof menuStructure === "function") {
      resolvedMenuStructure = menuStructure(availableIntegrations);
    }

    if (
      resolvedMenuStructure &&
      typeof resolvedMenuStructure !== "function" &&
      resolvedMenuStructure.title === "Reports"
    ) {
      const dataExportsEnabled =
        this.context?.featureFlags?.[DATA_EXPORTS] === "on";
      return getReportsMenuStructure(dataExportsEnabled);
    }

    return resolvedMenuStructure;
  }

  componentDidMount() {
    this.previousDataExportsFlag = this.context?.featureFlags?.[DATA_EXPORTS];
    const resolvedMenuStructure = this.getResolvedMenuStructure();
    if (resolvedMenuStructure && typeof resolvedMenuStructure !== "function") {
      this.props.store.MenuStore.setSideMenuToDisplay(resolvedMenuStructure);
    }
  }

  componentDidUpdate(prevProps: SetActiveMenuProps) {
    const { menuStructure, availableIntegrations, store } = this.props;
    const currentDataExportsFlag = this.context?.featureFlags?.[DATA_EXPORTS];
    const dataExportsFlagChanged =
      currentDataExportsFlag !== this.previousDataExportsFlag;

    if (
      prevProps.menuStructure === menuStructure &&
      prevProps.availableIntegrations === availableIntegrations &&
      !dataExportsFlagChanged
    ) {
      return;
    }
    const { MenuStore } = store;
    const resolvedMenuStructure = this.getResolvedMenuStructure();
    if (resolvedMenuStructure && typeof resolvedMenuStructure !== "function") {
      MenuStore.setSideMenuToDisplay(resolvedMenuStructure);
    }

    this.previousDataExportsFlag = currentDataExportsFlag;
  }

  render() {
    return null;
  }
}

export default SetActiveMenu;
